module.exports = __webpack_public_path__ + "static/bg-be5709264a1b0108db743426c53f10bd.svg";